import React from "react";
import Logo from "./Logo";
import { COMPANY, NAV_LINKS, SERVICES } from "@/lib/siteData";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0f0f0f] border-t border-white/10"
    >
      {/* Marquee */}
      <div className="overflow-hidden border-b border-white/10 py-5 bg-[#c41e3a]">
        <div className="flex whitespace-nowrap animate-marquee">
          {Array.from({ length: 2 }).flatMap((_, r) =>
            [
              "URETHANE FOAM ROOFING",
              "WATERPROOF COATINGS",
              "FOAM INSULATION",
              "COMMERCIAL · RESIDENTIAL · INDUSTRIAL",
              "SASKATOON · SK",
            ].map((t, i) => (
              <span
                key={`${r}-${i}`}
                className="font-display font-black text-white uppercase tracking-[0.08em] text-2xl md:text-3xl mx-8 inline-flex items-center gap-8"
              >
                {t}
                <span className="inline-block w-2 h-2 bg-white rotate-45" />
              </span>
            ))
          )}
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo />
            <p className="font-body text-white/60 text-base mt-6 max-w-sm leading-relaxed">
              Saskatoon&apos;s urethane roofing specialists. Commercial, residential,
              and industrial roof systems built to survive the prairies.
            </p>
            <div className="mt-6 space-y-2 text-white/70 text-[14px]">
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                className="block hover:text-[#c41e3a] transition-colors"
              >
                {COMPANY.phone}
              </a>
              <a
                href={`mailto:${COMPANY.email}`}
                className="block hover:text-[#c41e3a] transition-colors"
              >
                {COMPANY.email}
              </a>
              <div>{COMPANY.address}</div>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono-upper text-[11px] text-[#c41e3a] mb-5">
              Navigate
            </h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="font-body text-white/70 hover:text-white text-[14px] transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-mono-upper text-[11px] text-[#c41e3a] mb-5">
              Services
            </h4>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {SERVICES.map((s) => (
                <li key={s.number}>
                  <a
                    href="#services"
                    className="font-body text-white/70 hover:text-white text-[14px] transition-colors"
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-mono-upper text-[10px] text-white/50">
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <p className="font-mono-upper text-[10px] text-white/40">
            Built in {COMPANY.city}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
